module.exports = __webpack_public_path__ + "img/gf-icon.dc0f4271.png";